import {PureComponent} from 'react'
import {connect} from 'react-redux'
import PropTypes from 'prop-types'

import DefaultLayout from '../../../Layout/DefaultLayout.jsx'
import FreelanceSearchActiveFilters from './Components/FreelanceSearchActiveFilters.jsx'
import FreelanceSearchIACard from '../../../../components/SearchCard/FreelanceIA/FreelanceSearchIACard.jsx'
import FreelanceSearchIASidePanel from '../SearchIA/Components/FreelanceSearchIASidePanel.jsx'
import FreelanceSearchFilterSidebar from './Components/FreelanceSearchFilterSidebar.jsx'
import FilterOrder from '../../../../../shared/components/FilterOrder/FilterOrder.jsx'
import Loader from '../../../../../shared/components/Loader/Loader.jsx'
import SearchBar from '../../../../components/SearchBar/SearchBar.jsx'
import SearchResultsPaginated from '../../../Search/Components/SearchResultsPaginated.jsx'
import SubscribeBanner from '../../../../components/SubscribeBanner/SubscribeBanner.jsx'

import conf from '../../../../conf.js'

import {isUserDo} from "../../../../../shared/services/userService.js"

import '../../../Search/SearchIA.scss'
import './FreelanceSearchResultsContainer.scss'

class FreelanceSearchResultsContainer extends PureComponent {
  static propTypes = {
    currentUniverseId: PropTypes.number,
    currentUser: PropTypes.object,
    flattenSearchObject: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    isAdmin: PropTypes.bool.isRequired,
    search: PropTypes.func.isRequired,
    searchQuery: PropTypes.object.isRequired,
    searchPage: PropTypes.number,
    searchRouteName: PropTypes.string.isRequired,
    searchTarget: PropTypes.string.isRequired,
    userMainUniverseId: PropTypes.number,
  }

  static defaultProps = {
    currentUniverseId: null,
    loading: true,
    searchPage: 1,
    userMainUniverseId: null,
  }

  static filters = {
    orders: [
      {
        name: 'sort_tjm',
        label: 'TJM',
        tooltip: 'Tri par TJM',
        mustBeAdmin: true,
      },
      {
        name: 'sort_availability',
        label: 'Disponibilité',
        tooltip: 'Tri par disponibilité',
        mustBeConnected: true,
      },
      {
        name: 'sort_date_next_action',
        label: 'Date',
        tooltip: 'Tri par date de relance',
        mustBeAdmin: true,
      }
    ],
    freelanceSearchOrders : [
      {
        name: 'sort_availability',
        label: 'Disponibilité',
        tooltip: 'Tri par disponibilité',
        mustBeConnected: true,
      },
    ],
    adminOnlyRequirements: true,
    requirementChoices: [
      {text: 'Défaut'},
      {value: 1, text: 'ID (Sans le #)'},
      {value: 2, text: 'Nom / Prénom'},
      {value: 3, text: 'Email'},
      {value: 4, text: 'Téléphone'},
      {value: 5, text: 'Commentaires'}
    ]
  }

  constructor(props) {
    super(props)
    this.state = {
      selectedIndex: null,
    }
  }

  componentDidUpdate(prevProps) {
    if (this.state.selectedIndex !== null && prevProps.searchData?.results !== this.props.searchData?.results) {
      this.setState({selectedIndex: null})
    }
  }

  handleSelectFreelance = (index) => {
    this.setState({selectedIndex: index})
  }

  handleCloseSidePanel = () => {
    this.setState({selectedIndex: null})
  }

  handlePrevFreelance = () => {
    const total = this.props.searchData?.results?.length ?? 0
    if (!total) return
    this.setState((prevState) => ({selectedIndex: (prevState.selectedIndex - 1 + total) % total}))
  }

  handleNextFreelance = () => {
    const total = this.props.searchData?.results?.length ?? 0
    if (!total) return
    this.setState((prevState) => ({selectedIndex: (prevState.selectedIndex + 1) % total}))
  }

  renderFreelances = (freelances) => {
    const {selectedIndex} = this.state
    const scores = this.props.searchData?.scores

    return (
      <div className="dashboard-search-ia__results">
        {freelances.map((freelance, index) => (
          <FreelanceSearchIACard
            currentUser={this.props.currentUser}
            freelance={freelance}
            isAdmin={this.props.isAdmin}
            key={freelance.id}
            matchPercentage={null}
            score={scores?.[freelance.id] ?? null}
            selected={selectedIndex === index}
            onOpen={() => this.handleSelectFreelance(index)}
          />
        ))}
      </div>
    )
  }

  render() {
    const {selectedIndex} = this.state
    const results = this.props.searchData?.results?.length ? this.props.searchData.results : []

    const availabilityOrders = (FreelanceSearchResultsContainer.filters.freelanceSearchOrders || [])
      .filter((item) => !((item.mustBeAdmin && !this.props.isAdmin) || (item.mustBeConnected && !this.props.currentUser)))

    const orderControl = availabilityOrders.length ? availabilityOrders.map((item) => (
      <FilterOrder
        key={item.name}
        searchQuery={this.props.searchQuery}
        onChange={this.props.search}
        name={item.name}
        label={item.label}
        tooltip={item.tooltip}
        className="filter"
      />
    )) : null

    return (
      <DefaultLayout navbarContained={false} navbarSearch={false}>
        <div className="container-fluid container-search">
          <div className="row row-search">
            <FreelanceSearchFilterSidebar
              conf={conf}
              currentUniverseId={this.props.currentUniverseId}
              currentUser={this.props.currentUser}
              filters={FreelanceSearchResultsContainer.filters}
              isAdmin={this.props.isAdmin}
              isSecteurs={this.props.isAdmin || isUserDo(this.props.currentUser)}
              isLanguages={this.props.isAdmin || isUserDo(this.props.currentUser)}
              isItSkills={this.props.isAdmin || isUserDo(this.props.currentUser)}
              onChange={this.props.search}
              searchQuery={this.props.searchQuery}
              topologies={conf.search.topologies.freelances}
              userMainUniverseId={this.props.userMainUniverseId}
            />

            <div className="container dashboard-search">
              <FreelanceSearchActiveFilters
                isAdmin={this.props.isAdmin}
                isSecteurs={this.props.isAdmin || isUserDo(this.props.currentUser)}
                isLanguages={this.props.isAdmin || isUserDo(this.props.currentUser)}
                isItSkills={this.props.isAdmin || isUserDo(this.props.currentUser)}
                onChange={this.props.search}
                requirementChoices={FreelanceSearchResultsContainer.filters.requirementChoices}
                searchQuery={this.props.searchQuery}
              />

              <SearchBar
                onChange={this.props.search}
                className="freelance-search-topbar"
                searchQuery={this.props?.searchQuery ?? {}}
                showKeywordsSearch={false}
                showUniverseFilter={false}
                skillsTreePosition="end"
                orderControl={orderControl}
                filters={FreelanceSearchResultsContainer.filters}
                target={this.props.searchTarget}
                topologies={conf.search.topologies.freelances}
                resultsCount={this.props?.searchData?.pagination?.totalCount ?? 0}
                activeCount={this.props?.searchData?.activeCount ?? 0}
                conf={conf}
              />

              <SubscribeBanner
                currentUser={this.props.currentUser}
                search={this.props.search}
                searchUniverseId={null}
                target={this.props.searchTarget}
              />

              {this.props.loading ?
                <div className="p-5 p-relative">
                  <Loader visible={true} fill={false} contains={true} containsClassName="my-5">
                    Recherche en cours...
                  </Loader>
                </div> :
                <SearchResultsPaginated
                  className="search-results"
                  flattenSearchObject={this.props.flattenSearchObject}
                  pagination={this.props?.searchData?.pagination ?? {}}
                  renderResults={(freelances) => this.renderFreelances(freelances)}
                  results={results}
                  routeName={this.props.searchRouteName}
                  searchQuery={this.props.searchQuery}
                />
              }
            </div>

            {selectedIndex !== null && results[selectedIndex] && (
              <FreelanceSearchIASidePanel
                freelance={results[selectedIndex]}
                currentUser={this.props.currentUser}
                isAdmin={this.props.isAdmin}
                matchPercentage={null}
                index={selectedIndex}
                total={results.length}
                onPrev={this.handlePrevFreelance}
                onNext={this.handleNextFreelance}
                onClose={this.handleCloseSidePanel}
              />
            )}
          </div>
        </div>
      </DefaultLayout>
    )
  }
}

export default connect(
  (state) => ({
    currentUniverseId: state.universe?.currentUniverse?.id ?? null,
    searchData: state.search,
    userMainUniverseId: state.currentUser?.user?.mainUniverse ?? null,
  }),
)(FreelanceSearchResultsContainer)
